"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ContentContainer = _interopRequireDefault(require("../components/layout/ContentContainer"));
var _confirmationDialog = require("@common/components/confirmation-dialog/confirmation-dialog");
var _ClausesTab = _interopRequireDefault(require("../components/library/ClausesTab"));
var _PromptsTab = _interopRequireDefault(require("../components/library/PromptsTab"));
var _MemoriesTab = require("@common/components/saved-items/MemoriesTab");
var _ResourceSharePopover = require("../components/share/ResourceSharePopover");
var _resourceShareCopy = require("@common/components/share/resource-share-dialog/resource-share-copy");
var _useDioptraFetch2 = require("../hooks/use-dioptra-fetch");
var _AuthContext = require("../context/AuthContext");
var _useMemoriesApi = require("../hooks/use-memories-api");
var _useLearningsApi = require("../hooks/use-learnings-api");
var _webApi = require("../utils/web-api");
var _SavedPromptsContext = require("../context/SavedPromptsContext");
var _PageContext = require("../context/PageContext");
var _document = require("../utils/document");
var _toast = require("../utils/toast");
var _AnalyticsContext = require("../context/AnalyticsContext");
var _WordDocumentContext = require("../context/WordDocumentContext");
var _userPermissions = _interopRequireDefault(require("../constants/user-permissions"));
var _envManager = require("../utils/envManager");
var _materialSymbols = require("@design/icons/material-symbols");
var _button = require("@design/ui/button");
var _savedItemsToolbar = require("@common/components/saved-items/saved-items-toolbar");
var _branding = require("../utils/branding");
var _SegmentedControl = _interopRequireDefault(require("../components/common/SegmentedControl"));
var _FloatingActionBar = _interopRequireDefault(require("../components/common/FloatingActionBar"));
var _BottomToolbarContext = require("../context/BottomToolbarContext");
var _promptHelpers = require("../utils/prompt-helpers");
var _promptAccess = require("@common/utils/promptAccess");
var _analytics = require("@common/analytics");
var _foldedTextSearch = require("@common/utils/foldedTextSearch");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t1 in e) "default" !== _t1 && {}.hasOwnProperty.call(e, _t1) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t1)) && (i.get || i.set) ? o(f, _t1, i) : f[_t1] = e[_t1]); return f; })(e, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var DEFAULT_CURRENT_PAGE = 0;
var ITEMS_PER_PAGE = 25;
var LibraryPage = function LibraryPage() {
  var _user$hasManagePrompt;
  var _usePage = (0, _PageContext.usePage)(),
    pageParams = _usePage.pageParams;
  var _useState = (0, _react.useState)(pageParams.activeTab || "clauses"),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  var _useState3 = (0, _react.useState)(""),
    _useState4 = _slicedToArray(_useState3, 2),
    searchQuery = _useState4[0],
    setSearchQuery = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  var _useState7 = (0, _react.useState)(DEFAULT_CURRENT_PAGE),
    _useState8 = _slicedToArray(_useState7, 2),
    currentPage = _useState8[0],
    setCurrentPage = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState0 = _slicedToArray(_useState9, 2),
    totalClauses = _useState0[0],
    setTotalClauses = _useState0[1];
  var _useState1 = (0, _react.useState)([]),
    _useState10 = _slicedToArray(_useState1, 2),
    clauseTags = _useState10[0],
    setClauseTags = _useState10[1];
  var _useState11 = (0, _react.useState)("all"),
    _useState12 = _slicedToArray(_useState11, 2),
    promptFilterMode = _useState12[0],
    setPromptFilterMode = _useState12[1];
  var _useState13 = (0, _react.useState)([]),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedCategoryFilters = _useState14[0],
    setSelectedCategoryFilters = _useState14[1];
  (0, _react.useEffect)(function () {
    if (pageParams.activeTab && pageParams.activeTab !== activeTab) {
      setActiveTab(pageParams.activeTab);
    }
  }, [pageParams.activeTab]);

  // Reload prompts/skills when returning from PromptPage
  (0, _react.useEffect)(function () {
    if (pageParams.activeTab === "prompts") {
      loadPrompts("chat");
    } else if (pageParams.activeTab === "skills") {
      loadPrompts("skill");
    }
  }, [pageParams.activeTab]);
  var _useState15 = (0, _react.useState)([]),
    _useState16 = _slicedToArray(_useState15, 2),
    clauses = _useState16[0],
    setClauses = _useState16[1];
  var _useState17 = (0, _react.useState)("all"),
    _useState18 = _slicedToArray(_useState17, 2),
    clauseMode = _useState18[0],
    setClauseMode = _useState18[1];
  var _useState19 = (0, _react.useState)([]),
    _useState20 = _slicedToArray(_useState19, 2),
    selectedClauseTags = _useState20[0],
    setSelectedClauseTags = _useState20[1];
  var _useState21 = (0, _react.useState)(false),
    _useState22 = _slicedToArray(_useState21, 2),
    useSelectionSimilarity = _useState22[0],
    setUseSelectionSimilarity = _useState22[1];
  var _useState23 = (0, _react.useState)(null),
    _useState24 = _slicedToArray(_useState23, 2),
    selectedClauseId = _useState24[0],
    setSelectedClauseId = _useState24[1];
  var _useState25 = (0, _react.useState)(null),
    _useState26 = _slicedToArray(_useState25, 2),
    clauseShareTarget = _useState26[0],
    setClauseShareTarget = _useState26[1];
  var memoriesApi = (0, _useMemoriesApi.useMemoriesApi)();
  var learningsApi = (0, _useLearningsApi.useLearningsApi)();
  var memoryApis = (0, _react.useMemo)(function () {
    return [memoriesApi, learningsApi];
  }, [memoriesApi, learningsApi]);
  var _useState27 = (0, _react.useState)(false),
    _useState28 = _slicedToArray(_useState27, 2),
    showDeleteDialog = _useState28[0],
    setShowDeleteDialog = _useState28[1];
  var _useState29 = (0, _react.useState)(null),
    _useState30 = _slicedToArray(_useState29, 2),
    promptToDelete = _useState30[0],
    setPromptToDelete = _useState30[1];
  var _useState31 = (0, _react.useState)(null),
    _useState32 = _slicedToArray(_useState31, 2),
    clauseToDeleteId = _useState32[0],
    setClauseToDeleteId = _useState32[1];
  var _useState33 = (0, _react.useState)(false),
    _useState34 = _slicedToArray(_useState33, 2),
    showPublishDialog = _useState34[0],
    setShowPublishDialog = _useState34[1];
  var _useState35 = (0, _react.useState)(null),
    _useState36 = _slicedToArray(_useState35, 2),
    promptToPublish = _useState36[0],
    setPromptToPublish = _useState36[1];
  var _useState37 = (0, _react.useState)(null),
    _useState38 = _slicedToArray(_useState37, 2),
    shareTarget = _useState38[0],
    setShareTarget = _useState38[1];
  var _useSavedPrompts = (0, _SavedPromptsContext.useSavedPrompts)(),
    promptsByType = _useSavedPrompts.promptsByType,
    loadPrompts = _useSavedPrompts.loadPrompts,
    loadingByType = _useSavedPrompts.loadingByType;
  var prompts = (0, _react.useMemo)(function () {
    return promptsByType["chat"] || [];
  }, [promptsByType]);
  var promptsLoading = loadingByType["chat"];
  var skills = (0, _react.useMemo)(function () {
    return promptsByType["skill"] || [];
  }, [promptsByType]);
  var skillsLoading = loadingByType["skill"];
  var topLevelCategories = (0, _react.useMemo)(function () {
    return Array.from(new Set([].concat(_toConsumableArray(prompts), _toConsumableArray(skills)).map(function (p) {
      var _p$path;
      return (_p$path = p.path) === null || _p$path === void 0 ? void 0 : _p$path.split("/")[0];
    }).filter(Boolean))).sort();
  }, [prompts, skills]);
  var handleToggleCategoryFilter = function handleToggleCategoryFilter(category) {
    setSelectedCategoryFilters(function (prev) {
      return prev.includes(category) ? prev.filter(function (c) {
        return c !== category;
      }) : [].concat(_toConsumableArray(prev), [category]);
    });
  };
  var _useDioptraFetch = (0, _useDioptraFetch2.useDioptraFetch)(),
    dioptraFetch = _useDioptraFetch.dioptraFetch;
  var authHeader = (0, _AuthContext.useAuthHeader)();
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError,
    analytics = _useAnalytics.analytics;
  var _useWordDocument = (0, _WordDocumentContext.useWordDocument)(),
    selectedText = _useWordDocument.selectedText,
    isWriteRestricted = _useWordDocument.isWriteRestricted;
  var _usePage2 = (0, _PageContext.usePage)(),
    showPage = _usePage2.showPage;
  var _useAuthInfo = (0, _AuthContext.useAuthInfo)(),
    userClass = _useAuthInfo.userClass,
    orgHelper = _useAuthInfo.orgHelper,
    user = _useAuthInfo.user;
  var orgId = orgHelper === null || orgHelper === void 0 ? void 0 : orgHelper.getOrgIds()[0];
  var currentUserId = user === null || user === void 0 ? void 0 : user.userId;
  var canManagePrompts = (_user$hasManagePrompt = user === null || user === void 0 ? void 0 : user.hasManagePromptsPermission) !== null && _user$hasManagePrompt !== void 0 ? _user$hasManagePrompt : false;
  var _useBottomToolbar = (0, _BottomToolbarContext.useBottomToolbar)(),
    setActionSlot = _useBottomToolbar.setActionSlot;

  // Load clauses — all filtering/sorting/ranking happens server-side.
  // Out-of-order responses (e.g. while typing in search) must not clobber the
  // latest one, so each call takes an id and only the newest applies state.
  var latestClauseLoadIdRef = _react.default.useRef(0);
  var loadClauses = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var page,
        queryOverride,
        loadId,
        query,
        mode,
        response,
        _args = arguments,
        _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            page = _args.length > 0 && _args[0] !== undefined ? _args[0] : 0;
            queryOverride = _args.length > 1 ? _args[1] : undefined;
            if (authHeader) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            loadId = ++latestClauseLoadIdRef.current;
            setIsLoading(true);
            _context.p = 2;
            query = queryOverride !== null && queryOverride !== void 0 ? queryOverride : searchQuery;
            mode = clauseMode === "mine" ? "mine" : clauseMode === "shared" ? "shared" : "all";
            _context.n = 3;
            return (0, _webApi.searchUserClauses)(authHeader, {
              mode: mode,
              q: query || undefined,
              tags: selectedClauseTags.length ? selectedClauseTags : undefined,
              similarTo: useSelectionSimilarity && selectedText ? selectedText : undefined,
              offset: page * ITEMS_PER_PAGE,
              limit: ITEMS_PER_PAGE
            });
          case 3:
            response = _context.v;
            if (!(loadId !== latestClauseLoadIdRef.current)) {
              _context.n = 4;
              break;
            }
            return _context.a(2);
          case 4:
            setClauses(response.clauses || []);
            setTotalClauses(response.total || 0);
            _context.n = 7;
            break;
          case 5:
            _context.p = 5;
            _t = _context.v;
            if (!(loadId !== latestClauseLoadIdRef.current)) {
              _context.n = 6;
              break;
            }
            return _context.a(2);
          case 6:
            console.error("Failed to load clauses:", _t);
            sendError(_t, {
              component: "LibraryPage",
              action: "load_clauses"
            });
            (0, _toast.toastError)("Failed to load clauses");
          case 7:
            _context.p = 7;
            if (loadId === latestClauseLoadIdRef.current) {
              setIsLoading(false);
            }
            return _context.f(7);
          case 8:
            return _context.a(2);
        }
      }, _callee, null, [[2, 5, 7, 8]]);
    }));
    return function loadClauses() {
      return _ref.apply(this, arguments);
    };
  }();

  // Tags scoped to the clauses the user can access (powers the tag filter facet).
  var loadClauseTags = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _t2, _t3;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            if (authHeader) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2);
          case 1:
            _context2.p = 1;
            _t2 = setClauseTags;
            _context2.n = 2;
            return (0, _webApi.fetchUserClauseTags)(authHeader);
          case 2:
            _t2(_context2.v);
            _context2.n = 4;
            break;
          case 3:
            _context2.p = 3;
            _t3 = _context2.v;
            console.error("Failed to load clause tags:", _t3);
          case 4:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function loadClauseTags() {
      return _ref2.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    setSelectedClauseId(null);
    if (activeTab === "clauses") {
      setCurrentPage(DEFAULT_CURRENT_PAGE);
      loadClauses(0);
      loadClauseTags();
    } else if (activeTab === "prompts") {
      loadPrompts("chat");
    } else if (activeTab === "skills") {
      loadPrompts("skill");
    }
  }, [activeTab]);

  // Clearing the document selection turns similarity mode off (not just hides it).
  (0, _react.useEffect)(function () {
    if (!selectedText && useSelectionSimilarity) {
      setUseSelectionSimilarity(false);
    }
  }, [selectedText, useSelectionSimilarity]);

  // Reload clauses when any clause facet changes (mode / tags / selection-similarity)
  (0, _react.useEffect)(function () {
    if (activeTab === "clauses") {
      setCurrentPage(DEFAULT_CURRENT_PAGE);
      loadClauses(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clauseMode, selectedClauseTags, useSelectionSimilarity]);
  var handleSearch = function handleSearch(query) {
    setSearchQuery(query);
    if (activeTab === "clauses") {
      setCurrentPage(DEFAULT_CURRENT_PAGE);
      loadClauses(0, query);
    }
    // TODO: Implement search for prompts and memories
  };
  var handlePageChange = function handlePageChange(newPage) {
    setCurrentPage(newPage);
    loadClauses(newPage);
  };

  // Capture the current document selection as a new (owner-private) clause,
  // saved as plain text with tracked changes applied (no revision markup).
  var handleAddToLibrary = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
    var content, created, _t4;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          _context3.p = 0;
          if (!(!selectedText || !selectedText.length)) {
            _context3.n = 1;
            break;
          }
          return _context3.a(2);
        case 1:
          _context3.n = 2;
          return (0, _document.getSelectedReviewedText)();
        case 2:
          content = _context3.v;
          if (content.trim()) {
            _context3.n = 3;
            break;
          }
          return _context3.a(2);
        case 3:
          _context3.n = 4;
          return dioptraFetch("".concat((0, _envManager.getEnv)("WEBAPP_API_BASE_URL"), "/api/user-clauses"), {
            method: "POST",
            body: JSON.stringify({
              contentText: content
            })
          });
        case 4:
          created = _context3.v;
          (0, _toast.toastSuccess)("Clause added to library");
          // Open the new clause in edit mode so the user can add tags right away.
          if (created !== null && created !== void 0 && created.id) {
            showPage(_PageContext.PAGES.clausePage, {
              clause: created
            });
          } else {
            loadClauses(currentPage);
            loadClauseTags();
          }
          _context3.n = 6;
          break;
        case 5:
          _context3.p = 5;
          _t4 = _context3.v;
          console.error("Failed to add to library:", _t4);
          sendError(_t4, {
            component: "LibraryPage",
            action: "add_to_library"
          });
          (0, _toast.toastError)("Failed to add to library");
        case 6:
          return _context3.a(2);
      }
    }, _callee3, null, [[0, 5]]);
  })), [selectedText, currentPage]);

  // Row click selects a clause for insertion (toggle); the pencil opens the editor.
  var handleSelectClause = function handleSelectClause(clause) {
    setSelectedClauseId(function (prev) {
      return prev === clause.id ? null : clause.id;
    });
  };
  var handleOpenClause = function handleOpenClause(clause) {
    showPage(_PageContext.PAGES.clausePage, {
      clause: clause
    });
  };
  var handleInsertClause = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(clause) {
      var ok;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            if (!isWriteRestricted) {
              _context4.n = 1;
              break;
            }
            (0, _toast.toastError)("This document is read-only");
            return _context4.a(2);
          case 1:
            _context4.n = 2;
            return (0, _document.insertTextAtCursor)(clause.contentText);
          case 2:
            ok = _context4.v;
            if (ok) {
              (0, _toast.toastSuccess)("Clause inserted");
            } else {
              (0, _toast.toastError)("Failed to insert clause");
            }
          case 3:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return function handleInsertClause(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleShareClause = function handleShareClause(clause, anchorEl) {
    setClauseShareTarget({
      clause: clause,
      anchorEl: anchorEl
    });
  };
  var handleDeleteClause = function handleDeleteClause(clauseId) {
    setClauseToDeleteId(clauseId);
  };
  var handleDeleteClauseConfirm = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var clauseIdToDelete, _t5;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            if (!(!clauseToDeleteId || !authHeader)) {
              _context5.n = 1;
              break;
            }
            return _context5.a(2);
          case 1:
            clauseIdToDelete = clauseToDeleteId;
            setClauseToDeleteId(null);
            _context5.p = 2;
            _context5.n = 3;
            return (0, _webApi.deleteUserClause)(authHeader, clauseIdToDelete);
          case 3:
            (0, _toast.toastSuccess)("Clause deleted");
            loadClauses(currentPage);
            loadClauseTags();
            _context5.n = 5;
            break;
          case 4:
            _context5.p = 4;
            _t5 = _context5.v;
            console.error("Failed to delete clause:", _t5);
            sendError(_t5, {
              component: "LibraryPage",
              action: "delete_clause"
            });
            (0, _toast.toastError)("Failed to delete clause");
          case 5:
            return _context5.a(2);
        }
      }, _callee5, null, [[2, 4]]);
    }));
    return function handleDeleteClauseConfirm() {
      return _ref5.apply(this, arguments);
    };
  }();
  var handleDeleteClauseCancel = function handleDeleteClauseCancel() {
    setClauseToDeleteId(null);
  };
  var handleToggleClauseTag = function handleToggleClauseTag(tag) {
    setSelectedClauseTags(function (prev) {
      return prev.includes(tag) ? prev.filter(function (t) {
        return t !== tag;
      }) : [].concat(_toConsumableArray(prev), [tag]);
    });
  };
  var clauseFilterButtons = [{
    mode: "all",
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ListIcon, {
      width: 14,
      height: 14
    }),
    label: "All"
  }, {
    mode: "mine",
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.PersonIcon, {
      width: 14,
      height: 14
    }),
    label: "Mine"
  }, {
    mode: "shared",
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.GroupIcon, {
      width: 14,
      height: 14
    }),
    label: "Shared"
  }];
  var promptFilterButtons = [{
    mode: "all",
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ListIcon, {
      width: 14,
      height: 14
    }),
    label: "All"
  }, {
    mode: "managed",
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: (0, _branding.getBranding)().managedIcon,
      alt: "",
      width: 14,
      height: 14
    }),
    label: "Managed"
  }, {
    mode: "mine",
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.PersonIcon, {
      width: 14,
      height: 14
    }),
    label: "Mine"
  }, {
    mode: "team",
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.GroupIcon, {
      width: 14,
      height: 14
    }),
    label: "Team"
  }];
  var filterPromptOrSkill = function filterPromptOrSkill(p) {
    var _p$path2;
    var matchesQuery = (0, _foldedTextSearch.matchesSearch)(p.name, searchQuery) || (0, _foldedTextSearch.matchesSearch)(p.content, searchQuery);
    var isOwnedPrompt = (0, _promptHelpers.isUserPrompt)(p);
    var matchesFilterMode = promptFilterMode === "all" || promptFilterMode === "managed" && !isOwnedPrompt || promptFilterMode === "mine" && isOwnedPrompt && p.propelAuthUserID === currentUserId || promptFilterMode === "team" && isOwnedPrompt && (0, _promptAccess.isPromptSharedWithCaller)(p, currentUserId);
    var matchesCategoryFilter = selectedCategoryFilters.length === 0 || selectedCategoryFilters.includes(((_p$path2 = p.path) === null || _p$path2 === void 0 ? void 0 : _p$path2.split("/")[0]) || "");
    return matchesQuery && matchesFilterMode && matchesCategoryFilter;
  };
  var filterDeps = [searchQuery, currentUserId, promptFilterMode, selectedCategoryFilters];
  var filteredPrompts = (0, _react.useMemo)(function () {
    return prompts.filter(filterPromptOrSkill);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [prompts].concat(filterDeps));
  var filteredSkills = (0, _react.useMemo)(function () {
    return skills.filter(filterPromptOrSkill);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [skills].concat(filterDeps));
  var handleDeletePrompt = function handleDeletePrompt(prompt) {
    setPromptToDelete(prompt);
    setShowDeleteDialog(true);
  };
  function reloadAllPrompts() {
    loadPrompts("chat");
    loadPrompts("skill");
  }
  var handleDeleteConfirm = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
      var promptToDeleteCopy, _t6;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            if (promptToDelete) {
              _context6.n = 1;
              break;
            }
            return _context6.a(2);
          case 1:
            setShowDeleteDialog(false);
            promptToDeleteCopy = promptToDelete;
            setPromptToDelete(null);
            if (authHeader) {
              _context6.n = 2;
              break;
            }
            return _context6.a(2);
          case 2:
            _context6.p = 2;
            _context6.n = 3;
            return (0, _webApi.deleteUserPrompt)(authHeader, promptToDeleteCopy.id);
          case 3:
            reloadAllPrompts();
            _context6.n = 5;
            break;
          case 4:
            _context6.p = 4;
            _t6 = _context6.v;
            console.error("Failed to delete prompt:", _t6);
            sendError(_t6, {
              component: "LibraryPage",
              action: "delete_prompt"
            });
            (0, _toast.toastError)("Failed to delete prompt");
          case 5:
            return _context6.a(2);
        }
      }, _callee6, null, [[2, 4]]);
    }));
    return function handleDeleteConfirm() {
      return _ref6.apply(this, arguments);
    };
  }();
  var handleDeleteCancel = function handleDeleteCancel() {
    setShowDeleteDialog(false);
    setPromptToDelete(null);
  };
  var handlePublishPrompt = function handlePublishPrompt(prompt) {
    setPromptToPublish(prompt);
    setShowPublishDialog(true);
  };
  var handlePublishConfirm = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      var promptToCopy, _t7;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            if (promptToPublish) {
              _context7.n = 1;
              break;
            }
            return _context7.a(2);
          case 1:
            setShowPublishDialog(false);
            promptToCopy = promptToPublish;
            setPromptToPublish(null);
            if (authHeader) {
              _context7.n = 2;
              break;
            }
            return _context7.a(2);
          case 2:
            _context7.p = 2;
            _context7.n = 3;
            return (0, _webApi.publishUserPrompt)(authHeader, promptToCopy.id);
          case 3:
            (0, _toast.toastSuccess)("\"".concat(promptToCopy.name, "\" published as managed prompt"));
            reloadAllPrompts();
            _context7.n = 5;
            break;
          case 4:
            _context7.p = 4;
            _t7 = _context7.v;
            console.error("Failed to publish prompt:", _t7);
            sendError(_t7, {
              component: "LibraryPage",
              action: "publish_prompt"
            });
            (0, _toast.toastError)("Failed to publish prompt");
          case 5:
            return _context7.a(2);
        }
      }, _callee7, null, [[2, 4]]);
    }));
    return function handlePublishConfirm() {
      return _ref7.apply(this, arguments);
    };
  }();
  var handlePublishCancel = function handlePublishCancel() {
    setShowPublishDialog(false);
    setPromptToPublish(null);
  };
  var handleCreatePrompt = function handleCreatePrompt() {
    showPage(_PageContext.PAGES.promptPage, {
      prompt: {
        id: "",
        name: "",
        content: "",
        path: "",
        type: "chat"
      }
    });
  };
  var handleCreateSkill = function handleCreateSkill() {
    showPage(_PageContext.PAGES.promptPage, {
      prompt: {
        id: "",
        name: "",
        content: "",
        path: "",
        type: "skill"
      }
    });
  };
  var handleViewPrompt = function handleViewPrompt(prompt) {
    showPage(_PageContext.PAGES.promptPage, {
      prompt: prompt
    });
  };
  (0, _react.useEffect)(function () {
    var canAddToLibrary = orgId && userClass.hasPermission(orgId, _userPermissions.default.UseClauses) && selectedText && selectedText.length;
    var selectedClause = selectedClauseId ? clauses.find(function (c) {
      return c.id === selectedClauseId;
    }) : null;
    if (activeTab === "prompts") {
      setActionSlot(/*#__PURE__*/(0, _jsxRuntime.jsx)(_FloatingActionBar.default, {
        icon: "assets/plus.svg",
        label: "Create",
        onClick: handleCreatePrompt
      }));
    } else if (activeTab === "skills") {
      setActionSlot(/*#__PURE__*/(0, _jsxRuntime.jsx)(_FloatingActionBar.default, {
        icon: "assets/plus.svg",
        label: "Create",
        onClick: handleCreateSkill
      }));
    } else if (activeTab === "clauses" && selectedClause && !isWriteRestricted) {
      setActionSlot(/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        type: "button",
        onClick: function onClick() {
          return handleInsertClause(selectedClause);
        },
        className: "flex items-center gap-1.5 h-8 px-3 rounded-full bg-[var(--primary)] hover:bg-[var(--background-primary-hover)] text-white text-xs font-medium border-none cursor-pointer transition-colors",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ArrowBackIcon, {
          width: 14,
          height: 14,
          className: "text-white"
        }), "Insert"]
      }));
    } else if (activeTab === "clauses" && canAddToLibrary) {
      setActionSlot(/*#__PURE__*/(0, _jsxRuntime.jsx)(_FloatingActionBar.default, {
        icon: "assets/plus.svg",
        label: "Add",
        onClick: handleAddToLibrary
      }));
    } else {
      setActionSlot(null);
    }
    return function () {
      return setActionSlot(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, orgId, selectedText, handleAddToLibrary, selectedClauseId, clauses, isWriteRestricted]);
  var handleDownload = function handleDownload() {
    var items = activeTab === "skills" ? filteredSkills : filteredPrompts;
    var exportData = items.map(function (p) {
      var _p$description;
      var isUser = "propelAuthUserID" in p;
      return {
        source: isUser ? "user" : "managed",
        name: p.name,
        content: p.content,
        description: (_p$description = p.description) !== null && _p$description !== void 0 ? _p$description : null,
        type: p.type,
        path: p.path
      };
    });
    var blob = new Blob([JSON.stringify(exportData, null, 2)], {
      type: "application/json"
    });
    var url = URL.createObjectURL(blob);
    var date = new Date().toISOString().slice(0, 10);
    var filename = activeTab === "skills" ? "skills-export-".concat(date, ".json") : "prompts-export-".concat(date, ".json");
    var a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
    (0, _toast.toastSuccess)("Exported ".concat(exportData.length, " ").concat(activeTab === "skills" ? "skills" : "prompts"));
  };
  var handleUpload = function handleUpload() {
    var input = document.createElement("input");
    input.type = "file";
    input.accept = ".json";
    input.onchange = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(e) {
        var _files;
        var file, text, data, successCount, errorCount, _iterator, _step, item, _item$description, newPrompt, _t8, _t9, _t0;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              file = (_files = e.target.files) === null || _files === void 0 ? void 0 : _files[0];
              if (file) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2);
            case 1:
              if (authHeader) {
                _context8.n = 2;
                break;
              }
              return _context8.a(2);
            case 2:
              _context8.p = 2;
              _context8.n = 3;
              return file.text();
            case 3:
              text = _context8.v;
              data = JSON.parse(text);
              if (Array.isArray(data)) {
                _context8.n = 4;
                break;
              }
              (0, _toast.toastError)("Invalid file: expected a JSON array");
              return _context8.a(2);
            case 4:
              successCount = 0;
              errorCount = 0;
              _iterator = _createForOfIteratorHelper(data);
              _context8.p = 5;
              _iterator.s();
            case 6:
              if ((_step = _iterator.n()).done) {
                _context8.n = 12;
                break;
              }
              item = _step.value;
              if (!(!item.name || !item.content || !item.type)) {
                _context8.n = 7;
                break;
              }
              errorCount++;
              return _context8.a(3, 11);
            case 7:
              _context8.p = 7;
              _context8.n = 8;
              return (0, _webApi.createUserPrompt)(authHeader, {
                name: item.name,
                content: item.content,
                description: (_item$description = item.description) !== null && _item$description !== void 0 ? _item$description : null,
                type: item.type,
                path: item.path || ""
              });
            case 8:
              newPrompt = _context8.v;
              if (!(item.source === "managed")) {
                _context8.n = 9;
                break;
              }
              _context8.n = 9;
              return (0, _webApi.publishUserPrompt)(authHeader, newPrompt.id);
            case 9:
              successCount++;
              _context8.n = 11;
              break;
            case 10:
              _context8.p = 10;
              _t8 = _context8.v;
              console.error("Failed to import prompt:", item.name, _t8);
              errorCount++;
            case 11:
              _context8.n = 6;
              break;
            case 12:
              _context8.n = 14;
              break;
            case 13:
              _context8.p = 13;
              _t9 = _context8.v;
              _iterator.e(_t9);
            case 14:
              _context8.p = 14;
              _iterator.f();
              return _context8.f(14);
            case 15:
              if (successCount > 0) {
                (0, _toast.toastSuccess)("Imported ".concat(successCount, " ").concat(activeTab === "skills" ? "skills" : "prompts"));
              }
              if (errorCount > 0) {
                (0, _toast.toastError)("Failed to import ".concat(errorCount, " ").concat(activeTab === "skills" ? "skills" : "prompts"));
              }
              if (activeTab === "skills") {
                loadPrompts("skill");
              } else {
                loadPrompts("chat");
              }
              _context8.n = 17;
              break;
            case 16:
              _context8.p = 16;
              _t0 = _context8.v;
              console.error("Failed to parse import file:", _t0);
              sendError(_t0, {
                component: "LibraryPage",
                action: "upload_prompts"
              });
              (0, _toast.toastError)("Failed to parse import file");
            case 17:
              return _context8.a(2);
          }
        }, _callee8, null, [[7, 10], [5, 13, 14, 15], [2, 16]]);
      }));
      return function (_x2) {
        return _ref8.apply(this, arguments);
      };
    }();
    input.click();
  };
  var isPromptsOrSkills = activeTab === "prompts" || activeTab === "skills";
  var promptKindPlural = activeTab === "skills" ? "skills" : "prompts";
  var similarityToggle = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, {
    variant: useSelectionSimilarity ? "default" : "outline",
    size: "sm",
    "aria-pressed": useSelectionSimilarity,
    disabled: !selectedText,
    title: selectedText ? "Search by your selected text" : "Select text in the document to search by similarity",
    onClick: function onClick() {
      return setUseSelectionSimilarity(function (previous) {
        return !previous;
      });
    },
    className: "shrink-0 rounded-full",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.SelectIcon, {}), selectedText && "Similarity"]
  });
  var promptTransferActions = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex items-center gap-1 shrink-0",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      variant: "ghost",
      size: "icon-sm",
      onClick: handleDownload,
      "aria-label": "Export filtered ".concat(promptKindPlural, " as JSON"),
      title: "Export filtered ".concat(promptKindPlural, " as JSON"),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.DownloadIcon, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      variant: "ghost",
      size: "icon-sm",
      onClick: handleUpload,
      "aria-label": "Import ".concat(promptKindPlural, " from JSON"),
      title: "Import ".concat(promptKindPlural, " from JSON"),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.UploadIcon, {})
    })]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ContentContainer.default, {
    className: "flex flex-col h-full",
    "data-sentry-element": "ContentContainer",
    "data-sentry-component": "LibraryPage",
    "data-sentry-source-file": "LibraryPage.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SegmentedControl.default, {
      tabs: [{
        key: "clauses",
        label: "Clauses"
      }, {
        key: "prompts",
        label: "Prompts"
      }, {
        key: "memories",
        label: "Memories"
      }, {
        key: "skills",
        label: "Skills"
      }],
      activeKey: activeTab,
      onChange: function onChange(key) {
        return setActiveTab(key);
      },
      "data-sentry-element": "SegmentedControl",
      "data-sentry-source-file": "LibraryPage.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex-1 overflow-y-auto",
      children: [activeTab === "clauses" && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "sticky top-0 z-10 bg-background-canvas",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_savedItemsToolbar.SavedItemsToolbar, {
          activeFilter: clauseMode,
          onFilterChange: setClauseMode,
          filterButtons: clauseFilterButtons,
          categories: clauseTags,
          selectedCategories: selectedClauseTags,
          onToggleCategory: handleToggleClauseTag,
          categoryLabel: "tag",
          searchQuery: searchQuery,
          onSearchChange: handleSearch,
          searchPlaceholder: "Search clauses\u2026",
          actions: similarityToggle
        })
      }), isPromptsOrSkills && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "sticky top-0 z-10 bg-background-canvas",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_savedItemsToolbar.SavedItemsToolbar, {
          activeFilter: promptFilterMode,
          onFilterChange: setPromptFilterMode,
          filterButtons: promptFilterButtons,
          categories: topLevelCategories,
          selectedCategories: selectedCategoryFilters,
          onToggleCategory: handleToggleCategoryFilter,
          searchQuery: searchQuery,
          onSearchChange: handleSearch,
          searchPlaceholder: "Search ".concat(activeTab, "\u2026"),
          actions: canManagePrompts && promptTransferActions
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "p-2",
        children: [activeTab === "clauses" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ClausesTab.default, {
          clauses: clauses,
          isLoading: isLoading,
          currentPage: currentPage,
          totalClauses: totalClauses,
          itemsPerPage: ITEMS_PER_PAGE,
          selectedClauseId: selectedClauseId,
          onSelectClause: handleSelectClause,
          onOpenClause: handleOpenClause,
          onShareClause: handleShareClause,
          onDeleteClause: handleDeleteClause,
          onPageChange: handlePageChange
        }), activeTab === "prompts" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_PromptsTab.default, {
          prompts: filteredPrompts,
          isLoading: promptsLoading,
          currentUserId: currentUserId,
          onViewPrompt: handleViewPrompt,
          onDeletePrompt: handleDeletePrompt,
          onShareOpen: function onShareOpen(prompt, anchorEl) {
            return setShareTarget({
              prompt: prompt,
              anchorEl: anchorEl
            });
          },
          onClickPrompt: function onClickPrompt(prompt) {
            (0, _analytics.trackPromptUsed)(analytics, {
              promptName: prompt.name || "Untitled",
              promptType: "chat",
              source: (0, _promptHelpers.isUserPrompt)(prompt) ? "user" : "managed",
              insertMode: "append",
              surface: "word-addin",
              isAuthor: (0, _promptHelpers.isUserPrompt)(prompt) ? (0, _promptAccess.isPromptOwner)(prompt, currentUserId) : undefined
            });
            showPage(_PageContext.PAGES.chatPage, {
              initialPrompt: prompt.content,
              promptId: (0, _promptHelpers.isUserPrompt)(prompt) ? prompt.id : undefined
            });
          },
          onPublishPrompt: canManagePrompts ? handlePublishPrompt : undefined
        }), activeTab === "memories" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MemoriesTab.MemoriesTab, {
          apis: memoryApis,
          onRun: learningsApi.run,
          onError: function onError(err, action) {
            sendError(err, {
              component: "LibraryPage",
              action: action
            });
            (0, _toast.toastError)("Something went wrong with memories");
          }
        }), activeTab === "skills" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_PromptsTab.default, {
          prompts: filteredSkills,
          isLoading: skillsLoading,
          emptyMessage: "No skills found",
          currentUserId: currentUserId,
          onViewPrompt: handleViewPrompt,
          onDeletePrompt: handleDeletePrompt,
          onShareOpen: function onShareOpen(prompt, anchorEl) {
            return setShareTarget({
              prompt: prompt,
              anchorEl: anchorEl
            });
          },
          onClickPrompt: function onClickPrompt(skill) {
            handleViewPrompt(skill);
            (0, _analytics.trackSkillOpened)(analytics, {
              skillId: skill.id,
              source: (0, _promptHelpers.isUserPrompt)(skill) ? "user" : "managed",
              surface: "word-addin"
            });
          },
          onPublishPrompt: canManagePrompts ? handlePublishPrompt : undefined,
          showDescription: true
        })]
      })]
    }), showDeleteDialog && promptToDelete && /*#__PURE__*/(0, _jsxRuntime.jsx)(_confirmationDialog.ConfirmationDialog, {
      tone: "destructive",
      title: "Confirm delete",
      message: "Are you sure you want to delete \"".concat(promptToDelete.name, "\"?"),
      confirmLabel: "Delete",
      onConfirm: handleDeleteConfirm,
      onCancel: handleDeleteCancel
    }), clauseToDeleteId && /*#__PURE__*/(0, _jsxRuntime.jsx)(_confirmationDialog.ConfirmationDialog, {
      tone: "destructive",
      title: "Confirm delete",
      message: "Are you sure you want to delete this clause?",
      confirmLabel: "Delete",
      onConfirm: handleDeleteClauseConfirm,
      onCancel: handleDeleteClauseCancel
    }), showPublishDialog && promptToPublish && /*#__PURE__*/(0, _jsxRuntime.jsx)(_confirmationDialog.ConfirmationDialog, {
      tone: "primary",
      title: "Publish as managed",
      message: "Are you sure you want to publish \"".concat(promptToPublish.name, "\" as a managed prompt? It will become an organization-level prompt visible to all users, and the original user prompt will be removed."),
      confirmLabel: "Publish",
      onConfirm: handlePublishConfirm,
      onCancel: handlePublishCancel
    }), shareTarget && shareTarget.prompt.id && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ResourceSharePopover.ResourceSharePopover, {
      resourceKind: "prompt",
      resourceId: shareTarget.prompt.id,
      resourceName: shareTarget.prompt.name,
      anchorEl: shareTarget.anchorEl,
      access: "access" in shareTarget.prompt ? shareTarget.prompt.access : undefined,
      onClose: function onClose() {
        return setShareTarget(null);
      }
    }, shareTarget.prompt.id), clauseShareTarget && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ResourceSharePopover.ResourceSharePopover, {
      resourceKind: "clause",
      resourceId: clauseShareTarget.clause.id,
      resourceName: (0, _resourceShareCopy.clauseShareTitle)(clauseShareTarget.clause.contentText),
      anchorEl: clauseShareTarget.anchorEl,
      access: clauseShareTarget.clause.access,
      onClose: function onClose() {
        setClauseShareTarget(null);
        loadClauses(currentPage);
      }
    }, clauseShareTarget.clause.id)]
  });
};
var _default = exports.default = LibraryPage;